import { createAsyncThunk } from "@reduxjs/toolkit";
import { UserPhoto } from '../../../@types/usePhotoGallery';

export const isFromCamera = createAsyncThunk(
    "isFromCamera",
    async (file: number) => {
        return file
    }
  );